import request from '@/utils/newOpenRequest'

export function getMemberList(data) {
  return request({
      url: '/open/open/fans/search',
      method: 'post',
      data,
  })
}
// 获取平台
export function getWxList() {
  return request({
      url: '/open/open/app/query',
      method: 'post',
  })
}
// 开放平台前台，流水记录
export function getRunningWater(data) {
  return request({
      url: '/open/open/app-balance-log/search',
      method: 'post',
      data
  })
}

// 开放平台前台，订单列表
export function getOrderList(data) {
  return request({
      url: '/kfc/open/open-kfc-orders/search',
      method: 'post',
      data,
  })
}

// 开放平台前台，导出订单列表
export function exportOrderList(data) {
  return request({
    url: '/kfc/open/open-kfc-orders/export',
    method: 'post',
    data,
    responseType: 'blob',
    // contentType: false,
    isExport: true,
    // filename: '订单列表' + new Date().utils
  })
}

// 开放前台 - 平台已结款金额计算
export function getMoney(data) {
  return request({
      url: '/open/open/app/get',
      method: 'post',
      data,
  })
}
// 获取授权地址
export function getAuthorizedLink(data) {
  return request({
      url: '/third/go/auth-pub-url',
      method: 'post',
      data,
  })
}
// 获取应用推广链接
export function getAppLink(data) {
  return request({
      url: '/open/open/app/open-list',
      method: 'post',
      data,
  })
}
// 开通肯德基
export function openKFC(data) {
  return request({
      url: '/open/open/app/open-kfc',
      method: 'post',
      data,
  })
}
// 开通电费
export function openElectricity(data) {
  return request({
      url: '/open/open/app/open-electricity',
      method: 'post',
      data,
  })
}
// 首页 - open主页
export function getopenIndexInfo(data) {
  return request({
      url: '/kfc/open/home/stat',
      method: 'post',
      data,
  })
}
// 应用开通 - 同步消息模板
export function asyncInfoTemplate(data) {
  return request({
      url: '/open/open/app-template/sync',
      method: 'post',
      data,
  })
}
// 订单列表-电费列表
export function getElectricityList(data) {
  return request({
      url: '/open/electricity/open/order/search',
      method: 'post',
      data,
  })
}

// 开放平台前台，导出订单列表
export function exportElectricityList(data) {
  return request({
    url: '/open/electricity/open/order/export',
    method: 'post',
    data,
    responseType: 'blob',
    // contentType: false,
    isExport: true,
    // filename: '订单列表' + new Date().utils
  })
}

// 报价浮动
export function updateDiscountFloat(data) {
  return request({
    url: 'open/open/ticket-royalty-mode/update-discount-float',
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/open.js